import React, { type ReactElement } from 'react';
import { MultiSessionDeviceSubs } from 'reactApp/appHelpers/featuresHelpers/features/multiSessionSubscriptions';
import { isImapSubscription } from 'reactApp/modules/billingData/billingData.types';
import { getMultiSessionFreeChoiceDescription, getMultiSessionPresetInSubsDescription } from 'reactApp/modules/payment/payment.helpers';
import { cheapestProductIDs } from 'reactApp/modules/products/products.const';
import { getPeriodName } from 'reactApp/utils/Period';
import { computersGenitive } from 'reactApp/utils/pluralHelpers';

export const usePaymentInfo = ({ isGrace, product, subscription, isSuccess }): { title?: string | ReactElement; description?: string } => {
    if (!subscription) {
        return {};
    }

    let title = <div>Продление периода тарифа на&nbsp;{subscription?.space?.value}</div>;
    let description =
        isGrace && product
            ? `Доплата за подписку +${product.space.space} ${product.space.units} на ${getPeriodName(product.period, false, true)} `
            : undefined;

    // tempexp_16598-start
    if (Object.values(cheapestProductIDs).includes(subscription.productId)) {
        title = <div>Продление периода тарифа Без рекламы</div>;
    }
    // tempexp_16598-end

    if (isGrace) {
        title = <div>Оплата подписки Mail Space&nbsp;{subscription?.space?.value}</div>;
    }

    if (isSuccess && !isGrace) {
        // tempexp_16598-start
        if (Object.values(cheapestProductIDs).includes(subscription.productId)) {
            title = <div>Вы продлили тариф Без рекламы</div>;
        }
        // tempexp_16598-end

        title = <div>Вы продлили тариф на&nbsp;{subscription?.space?.value}</div>;
    }

    /* tempexp_20439-start */
    if (!isGrace && product?.id && MultiSessionDeviceSubs.enabled) {
        const devices = MultiSessionDeviceSubs.getDeviceCount(product.id);
        if (MultiSessionDeviceSubs.isFreeChoiceProduct(product.id)) {
            title = (
                <div>
                    Продление: вход в&nbsp;Почту с&nbsp;{devices}&nbsp;{computersGenitive(devices)} на&nbsp;
                    {getPeriodName(product.period)}
                </div>
            );
            description = getMultiSessionFreeChoiceDescription(product);
        }
        if (MultiSessionDeviceSubs.isPresetInSubsProduct(product.id)) {
            title = (
                <div>
                    Продление: Mail&nbsp;Space Для&nbsp;работы и&nbsp;вход в Почту с {devices} {computersGenitive(devices)}
                </div>
            );
            description = getMultiSessionPresetInSubsDescription(product, subscription?.renewalCost);
        }
    }
    /* tempexp_20439-end */

    /* tempexp_20582-start */
    if (!isGrace && isImapSubscription(subscription)) {
        title = <div>Продление: создание паролей</div>;
        description = `В ${getPeriodName(product.period, false, true)} - любое количество паролей для внешних приложений`;
    }
    /* tempexp_20582-end */

    return {
        title,
        description,
    };
};
